import { SpectrumColor } from '../types';

export const Blue: SpectrumColor = {
  0: '#F6F9FE',
  5: '#F2F5FC',
  10: '#E9EFFC',
  15: '#E0E9FD',
  20: '#D7E3FE',
  25: '#C2D6FF',
  30: '#ADC8FF',
  35: '#9BBCFF',
  40: '#88AFFE',
  50: '#6698FC',
  60: '#5089FC',
  70: '#3370E9',
  80: '#185ADD',
  90: '#1347AD',
  100: '#0F3786',
  110: '#0B2863',
  default: 80,
};
